export default function (context) {
  const user = context.$auth.$storage.getState('user')

  if (!user.roles.includes('admin')) return context.redirect('/kanban')
}
